import styles from "./HeaderBar.module.scss";
import Assets from "../../Assets";
import SVG from "react-inlinesvg";
import {useDispatch } from "react-redux";
import MenuIcon from '@mui/icons-material/Menu';
import * as actions from '../../actions/index.js';
import ProfileMenu from "../common/CustomPopOver/CustomPopover.js";

const HeaderBar = () => {
  const dispatch = useDispatch();

const handleModalOpen = () => {
  dispatch(actions.setNavigationDrawerState());
};

  return (
      <div className={styles.OtisFixedHeader}>
        <div className={styles.OtisTopHeader}>
        <button type="button" className={styles.hamburgerMenu} onClick={handleModalOpen}> <MenuIcon /></button>
          <div className={styles.flexstart}>  
            <div className={styles.svgIcon}>
              <SVG src={Assets.otis_logo} alt="otis_icon"></SVG>
            </div>
          </div>
            <ProfileMenu />
        </div>
      </div>
  );
};

export { HeaderBar };
